import React, { useState, useEffect } from 'react';
import { Modal, Form } from 'react-bootstrap';

import { sortBy } from 'lodash'

import { ApiServiceServerless } from '../../../xhr_libs';
import AddEntityActionButtons from '../../forms/AddEntityActionButtons';

export default function ClonePlugMeterGroup(props) {
  const {
    show,
    onHide,
    showToast,
    meterGroups,
    setMeterGroups,
    setActiveMeterGroupId,
    organizationId,
  } = props;

  const [groupName, setGroupName] = useState('');
  const [cloneGroupId, setCloneGroupId] = useState('');


  const [disabled, setDisabled] = useState(true);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (groupName && cloneGroupId) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [groupName, cloneGroupId]);

  const cloneGroup = (e) => {
    e.preventDefault();
    setIsLoading(true);
    ApiServiceServerless.post(
      `/plug_meter_groups/clone/${cloneGroupId}`,
      {
        name: groupName,
      },
      { authorization_id: organizationId }
    )
      .then((res) => {
        setMeterGroups((prev) => [...prev, res.data]);
        setActiveMeterGroupId(res.data.id);
      })
      .catch((error) => {
        showToast('danger', 'Error', error);
        throw error;
      })
      .finally(() => {
        onHide();
        setIsLoading(false);
        resetModal();
      });
  };

  const resetModal = () => {
    setGroupName('');
  };

  useEffect(() => {
    if (show) {
      resetModal();
    }
  }, [show]);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>Clone Meter Group</Modal.Header>
      <Form onSubmit={cloneGroup}>
        <Modal.Body>
          <Form.Group>
            <Form.Label>
              {'Group Name'}
              <span className='text-warning font-weight-bold pl-1'>*</span>
            </Form.Label>
            <Form.Row>
              <Form.Control
                required
                placeholder=''
                onChange={(e) => setGroupName(e.target.value)}
              />
            </Form.Row>
          </Form.Group>
          <Form.Group>
            <Form.Label>
              Meter Group To Clone
              <span className='text-warning font-weight-bold pl-1'>*</span>
            </Form.Label>

            <Form.Control
              as='select'
              required
              onChange={(e) => {
                setCloneGroupId(parseInt(e.target.value));
              }}
            >
              <option key={'opt-null'} value={''} hidden>
                -
              </option>
              {meterGroups.length === 0 && (
                <option key={'null-null'} value={''} disabled>
                  No existing meter groups
                </option>
              )}
              {sortBy(meterGroups, ['name']).map((group) => (
                <option key={'opt-' + group.id} value={group.id}>
                  {group.name}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <AddEntityActionButtons
            onCancel={onHide}
            submitDisabled={disabled}
            isSubmitting={isLoading}
          />
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
